import { render, staticRenderFns } from "./AvailabilityRemark.vue?vue&type=template&id=071dc8a1&lang=pug"
import script from "./AvailabilityRemark.vue?vue&type=script&lang=js"
export * from "./AvailabilityRemark.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityRemark.vue?vue&type=style&index=0&id=071dc8a1&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/vantone/Icon.vue').default})
